import { Component, EventEmitter, Input, Output } from '@angular/core';

// The shell owns the chrome every modal shares: the cyan header with its
// left-aligned title and close button, and the right-aligned actions footer.
// Each modal projects its own body, so only the chrome is centralised.
@Component({
    selector: 'app-modal-shell',
    templateUrl: 'modal-shell.component.html',
    styleUrls: ['modal-shell.component.scss'],
    // The static title="..." attribute callers use to set the input also lands
    // in the DOM, where browsers show it as a hover tooltip; strip it.
    host: { class: 'modal modal-shell', '[attr.title]': 'null' },
    standalone: false
})
export class ModalShellComponent {
  @Input() title: string;

  @Output() dismissed = new EventEmitter<void>();
}
